import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    "data-testid": "public-service-listing",
    class: "w-full px-6 py-16 bg-white"
};
const _hoisted_2 = { class: "container mx-auto" };
const _hoisted_3 = { class: "flex flex-col gap-2 mb-8" };
const _hoisted_4 = { class: "text-3xl font-modulus-semi-bold text-eblack-500" };
const _hoisted_5 = { class: "max-w-2xl text-sm text-eblack-300" };
const _hoisted_6 = {
    key: 0,
    class: "text-sm text-eblack-300"
};
const _hoisted_7 = {
    key: 1,
    class: "text-sm text-red-600"
};
const _hoisted_8 = {
    key: 2,
    class: "grid gap-4 md:grid-cols-2 xl:grid-cols-3"
};
const _hoisted_9 = ["src", "alt"];
const _hoisted_10 = { class: "flex flex-col gap-3 p-4" };
const _hoisted_11 = { class: "flex flex-col gap-1" };
const _hoisted_12 = { class: "text-lg font-semibold text-eblack-500" };
const _hoisted_13 = {
    key: 0,
    class: "text-sm text-eblack-300"
};
const _hoisted_14 = {
    key: 0,
    class: "text-sm leading-6 text-eblack-400"
};
const _hoisted_15 = { class: "flex flex-wrap gap-2 text-xs text-eblack-300" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { key: 1 };
const _hoisted_18 = { key: 2 };
const _hoisted_19 = {
    key: 1,
    class: "flex items-center gap-1 text-xs text-amber-500"
};
const _hoisted_20 = {
    key: 2,
    class: "text-xs text-eblack-300"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
    key: 0,
    class: "fixed inset-0 z-[1000000] flex items-center justify-center bg-black/50 p-4",
    role: "dialog",
    "aria-modal": "true"
};
const _hoisted_23 = { class: "flex items-start justify-between gap-4" };
const _hoisted_24 = { class: "text-xl font-bold" };
const _hoisted_25 = ["aria-label"];
const _hoisted_26 = {
    key: 0,
    class: "mt-4 rounded bg-green-50 p-3 text-sm text-green-800"
};
const _hoisted_27 = { class: "mt-4 grid gap-3" };
const _hoisted_28 = ["disabled"];
const _hoisted_29 = {
    value: null,
    disabled: ""
};
const _hoisted_30 = ["value"];
const _hoisted_31 = {
    key: 0,
    class: "text-xs text-eblack-400"
};
const _hoisted_32 = ["disabled", "placeholder"];
const _hoisted_33 = ["disabled", "placeholder"];
const _hoisted_34 = ["disabled", "placeholder"];
const _hoisted_35 = ["disabled", "placeholder"];
const _hoisted_36 = ["disabled", "placeholder"];
const _hoisted_37 = ["disabled", "placeholder"];
const _hoisted_38 = {
    key: 0,
    class: "mt-4 rounded-lg border border-ewhite-200 p-3"
};
const _hoisted_39 = { class: "mt-2 flex justify-between border-t border-ewhite-200 pt-2 text-sm font-semibold" };
const _hoisted_40 = {
    key: 1,
    class: "mt-3 text-sm text-red-600"
};
const _hoisted_41 = ["disabled"];
const _hoisted_42 = ["disabled"];
import { computed, onMounted, ref, watch } from "vue";
import webRequest from "@/services/web/web-service";
import { i18n } from "@/i18n";
import { useBookingWidget } from "@/domains/booking-widget";
import { toPublicServiceListingItem, } from "../models/public-service-listing.model";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PublicServiceListing',
    props: {
        organizationId: {},
        catalogGrant: {},
        captchaRequired: { type: Boolean },
        turnstileSiteKey: {}
    },
    setup(__props) {
        const props = __props;
        const isGrantMode = computed(() => Boolean(props.organizationId && props.catalogGrant));
        const widget = useBookingWidget();
        // Legacy (non-grant) public listing — unrelated to access grants, kept as-is.
        const legacyServices = ref([]);
        const legacyLoading = ref(false);
        const legacyError = ref(null);
        function toListingItemFromCatalogService(service) {
            return {
                id: service.id,
                name: service.name,
                providerName: service.provider?.name,
                durationLabel: service.duration ? `${service.duration} min` : undefined,
                photoUrl: service.photoUrls[0],
                averageRating: service.reviewSummary?.averageRating ?? null,
                reviewCount: service.reviewSummary?.total ?? 0,
            };
        }
        const publicServices = computed(() => isGrantMode.value
            ? (widget.catalog.value?.services ?? []).map(toListingItemFromCatalogService)
            : legacyServices.value);
        const isLoading = computed(() => (isGrantMode.value ? widget.isLoading.value : legacyLoading.value));
        const error = computed(() => (isGrantMode.value ? widget.error.value : legacyError.value));
        const hasContent = computed(() => isLoading.value || Boolean(error.value) || publicServices.value.length > 0);
        onMounted(async () => {
            if (isGrantMode.value) {
                widget.configure({
                    apiBaseUrl: process.env.VUE_APP_API_URL || "",
                    organizationId: props.organizationId,
                    catalogGrant: props.catalogGrant,
                    captchaRequired: Boolean(props.captchaRequired),
                    turnstileSiteKey: props.turnstileSiteKey,
                });
                try {
                    await widget.loadCatalog();
                }
                catch {
                    // surfaced via widget.error
                }
                return;
            }
            legacyLoading.value = true;
            legacyError.value = null;
            try {
                const response = await webRequest.getServices();
                legacyServices.value = (response.data ?? []).map(toPublicServiceListingItem);
            }
            catch (err) {
                legacyError.value = err instanceof Error ? err.message : "Error loading public services";
            }
            finally {
                legacyLoading.value = false;
            }
        });
        // -----------------------------------------------------------------------------
        // Booking (grant mode only)
        // -----------------------------------------------------------------------------
        const selected = ref(null);
        const stage = ref("selecting");
        const selectedSlotIndex = ref(null);
        const partySize = ref(1);
        const firstName = ref("");
        const lastName = ref("");
        const email = ref("");
        const country = ref("CR");
        const phone = ref("");
        const slots = computed(() => widget.availability.value?.slots ?? []);
        const quote = computed(() => widget.intent.value?.quote ?? null);
        const bookingResult = widget.bookingResult;
        const isIntentInFlight = widget.isIntentInFlight;
        const isConfirming = widget.isConfirming;
        const bookingErrorMessage = computed(() => {
            if (widget.lastErrorStatus.value === 409)
                return i18n.global.t("marketing.public_booking.slot_unavailable");
            if (widget.lastErrorStatus.value === 429 && widget.retryAfterSeconds.value != null) {
                return i18n.global.t("marketing.public_booking.retry_after", { seconds: widget.retryAfterSeconds.value });
            }
            return widget.error.value;
        });
        function toDateOnly(date) {
            return date.toISOString().slice(0, 10);
        }
        async function refreshAvailability() {
            if (!selected.value)
                return;
            const from = new Date();
            const to = new Date();
            to.setDate(to.getDate() + 6);
            selectedSlotIndex.value = null;
            try {
                await widget.loadAvailability(selected.value.id, {
                    from: toDateOnly(from),
                    to: toDateOnly(to),
                    partySize: partySize.value,
                });
            }
            catch {
                // surfaced via widget.error
            }
        }
        async function openBooking(service) {
            selected.value = service;
            stage.value = "selecting";
            selectedSlotIndex.value = null;
            partySize.value = 1;
            firstName.value = "";
            lastName.value = "";
            email.value = "";
            country.value = "CR";
            phone.value = "";
            widget.clearIntent();
            await refreshAvailability();
        }
        function closeBooking() {
            selected.value = null;
            widget.clearIntent();
        }
        function formatSlotLabel(slot) {
            return `${new Date(slot.startDateTime).toLocaleString()} (${slot.remainingCapacity})`;
        }
        function formatAmount(amountMinor, currency) {
            return new Intl.NumberFormat(undefined, { style: "currency", currency }).format(amountMinor / 100);
        }
        async function getQuote() {
            if (!selected.value || selectedSlotIndex.value === null)
                return;
            const slot = slots.value[selectedSlotIndex.value];
            if (!slot)
                return;
            const proposal = {
                serviceId: selected.value.id,
                startDateTime: slot.startDateTime,
                endDateTime: slot.endDateTime,
                partySize: partySize.value,
                firstName: firstName.value,
                lastName: lastName.value,
                email: email.value,
                country: country.value,
                phone: phone.value || undefined,
            };
            try {
                await widget.createIntent(proposal);
                stage.value = "quoted";
            }
            catch {
                if (widget.lastErrorStatus.value === 409)
                    await refreshAvailability();
            }
        }
        async function confirm() {
            try {
                await widget.confirmBooking();
                stage.value = "confirmed";
            }
            catch {
                // surfaced via bookingErrorMessage; 400/404/409 already cleared the intent
                if (widget.lastErrorStatus.value && widget.lastErrorStatus.value !== 503)
                    stage.value = "selecting";
            }
        }
        watch(() => props.catalogGrant, () => {
            if (!isGrantMode.value)
                return;
            widget.configure({
                apiBaseUrl: process.env.VUE_APP_API_URL || "",
                organizationId: props.organizationId,
                catalogGrant: props.catalogGrant,
                captchaRequired: Boolean(props.captchaRequired),
                turnstileSiteKey: props.turnstileSiteKey,
            });
            widget.loadCatalog().catch(() => undefined);
        });
        return (_ctx, _cache) => {
            return (hasContent.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("marketing.auto.servicios_disponibles")), 1),
                            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("marketing.auto.explora_experiencias_publicadas_por_proveedores_")), 1)
                        ]),
                        (isLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t("marketing.auto.cargando_servicios")), 1))
                            : (error.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t("marketing.auto.no_pudimos_cargar_los_servicios")), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(publicServices.value, (service) => {
                                        return (_openBlock(), _createElementBlock("article", {
                                            key: service.id,
                                            "data-testid": "public-service-card",
                                            class: "overflow-hidden border rounded-lg border-ewhite-200 bg-ewhite-50"
                                        }, [
                                            (service.photoUrl)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: service.photoUrl,
                                                    alt: service.name,
                                                    class: "object-cover w-full h-40"
                                                }, null, 8, _hoisted_9))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_10, [
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createElementVNode("h3", _hoisted_12, _toDisplayString(service.name), 1),
                                                    (service.providerName)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(service.providerName), 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                (service.additionalInformation)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(service.additionalInformation), 1))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_15, [
                                                    (service.durationLabel)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(service.durationLabel), 1))
                                                        : _createCommentVNode("", true),
                                                    (service.categoryName)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(service.categoryName), 1))
                                                        : _createCommentVNode("", true),
                                                    (service.serviceTypeName)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(service.serviceTypeName), 1))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                (service.reviewCount > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                        _cache[8] || (_cache[8] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            class: "h-3.5 w-3.5 fill-amber-400 text-amber-400",
                                                            viewBox: "0 0 24 24",
                                                            stroke: "currentColor",
                                                            "stroke-width": "1.5",
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "aria-hidden": "true"
                                                        }, [
                                                            _createElementVNode("path", { d: "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z" })
                                                        ], -1)),
                                                        _createElementVNode("span", null, _toDisplayString(service.averageRating?.toFixed(1)) + " (" + _toDisplayString(service.reviewCount) + " " + _toDisplayString(_ctx.$t("reviews.catalog.reviews")) + ")", 1)
                                                    ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t("reviews.catalog.no_reviews")), 1)),
                                                (isGrantMode.value)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 3,
                                                        type: "button",
                                                        class: "rounded-lg bg-eorange-500 px-3 py-2 text-sm font-medium text-white",
                                                        onClick: ($event) => (openBooking(service))
                                                    }, _toDisplayString(_ctx.$t("marketing.public_booking.book")), 9, _hoisted_21))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ]));
                                    }), 128))
                                ]))
                    ]),
                    (selected.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("form", {
                                class: "max-h-full w-full max-w-lg overflow-y-auto rounded-xl bg-white p-6",
                                onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event) => (stage.value === 'quoted' ? confirm() : getQuote()), ["prevent"]))
                            }, [
                                _createElementVNode("div", _hoisted_23, [
                                    _createElementVNode("h2", _hoisted_24, _toDisplayString(_ctx.$t("marketing.public_booking.modal_title", { name: selected.value.name })), 1),
                                    _createElementVNode("button", {
                                        type: "button",
                                        "aria-label": _ctx.$t('marketing.public_booking.close'),
                                        onClick: closeBooking
                                    }, "×", 8, _hoisted_25)
                                ]),
                                (stage.value === 'confirmed')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.$t("marketing.public_booking.confirmation", { bookingId: _unref(bookingResult)?.bookingId })), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("div", _hoisted_27, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((selectedSlotIndex).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                class: "rounded border p-2"
                                            }, [
                                                _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t("marketing.public_booking.select_slot_placeholder")), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slots.value, (slot, index) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: slot.startDateTime,
                                                        value: index
                                                    }, _toDisplayString(formatSlotLabel(slot)), 9, _hoisted_30));
                                                }), 128))
                                            ], 8, _hoisted_28), [
                                                [_vModelSelect, selectedSlotIndex.value]
                                            ]),
                                            (!isLoading.value && slots.value.length === 0)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(_ctx.$t("marketing.public_booking.no_slots")), 1))
                                                : _createCommentVNode("", true),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((partySize).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                min: "1",
                                                max: "50",
                                                type: "number",
                                                placeholder: _ctx.$t('marketing.public_booking.party_size_placeholder'),
                                                class: "rounded border p-2",
                                                onChange: refreshAvailability
                                            }, null, 40, _hoisted_32), [
                                                [
                                                    _vModelText,
                                                    partySize.value,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((firstName).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                placeholder: _ctx.$t('marketing.public_booking.first_name_placeholder'),
                                                class: "rounded border p-2"
                                            }, null, 8, _hoisted_33), [
                                                [_vModelText, firstName.value]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((lastName).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                placeholder: _ctx.$t('marketing.public_booking.last_name_placeholder'),
                                                class: "rounded border p-2"
                                            }, null, 8, _hoisted_34), [
                                                [_vModelText, lastName.value]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((email).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                type: "email",
                                                placeholder: _ctx.$t('marketing.public_booking.email_placeholder'),
                                                class: "rounded border p-2"
                                            }, null, 8, _hoisted_35), [
                                                [_vModelText, email.value]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((country).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                required: "",
                                                minlength: "2",
                                                maxlength: "2",
                                                placeholder: _ctx.$t('marketing.public_booking.country_placeholder'),
                                                class: "rounded border p-2"
                                            }, null, 8, _hoisted_36), [
                                                [_vModelText, country.value]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((phone).value = $event)),
                                                disabled: stage.value === 'quoted',
                                                placeholder: _ctx.$t('marketing.public_booking.phone_placeholder'),
                                                class: "rounded border p-2"
                                            }, null, 8, _hoisted_37), [
                                                [_vModelText, phone.value]
                                            ])
                                        ]),
                                        (stage.value === 'quoted' && quote.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quote.value.lines, (line) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: line.label,
                                                        class: "flex justify-between text-sm text-eblack-500"
                                                    }, [
                                                        _createElementVNode("span", null, _toDisplayString(line.label), 1),
                                                        _createElementVNode("span", null, _toDisplayString(formatAmount(line.amountMinor, quote.value.currency)), 1)
                                                    ]));
                                                }), 128)),
                                                _createElementVNode("div", _hoisted_39, [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("marketing.public_booking.quote_total", { amount: formatAmount(quote.value.amountMinor, quote.value.currency) })), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true),
                                        (bookingErrorMessage.value)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(bookingErrorMessage.value), 1))
                                            : _createCommentVNode("", true),
                                        (stage.value === 'selecting')
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 2,
                                                disabled: _unref(isIntentInFlight),
                                                type: "submit",
                                                class: "mt-4 w-full rounded-lg bg-eorange-500 px-4 py-2 font-medium text-white disabled:opacity-60"
                                            }, _toDisplayString(_unref(isIntentInFlight) ? _ctx.$t("marketing.public_booking.getting_quote") : _ctx.$t("marketing.public_booking.get_quote")), 9, _hoisted_41))
                                            : (_openBlock(), _createElementBlock("button", {
                                                key: 3,
                                                disabled: _unref(isConfirming),
                                                type: "submit",
                                                class: "mt-4 w-full rounded-lg bg-eorange-500 px-4 py-2 font-medium text-white disabled:opacity-60"
                                            }, _toDisplayString(_unref(isConfirming) ? _ctx.$t("marketing.public_booking.confirming") : _ctx.$t("marketing.public_booking.confirm_booking")), 9, _hoisted_42))
                                    ], 64))
                            ], 32)
                        ]))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
